import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      meta: { main_page: true },
      component: () => import("@/core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/smartSecretary",
          name: "smartSecretary",
          meta: { title: "منشی پیام", has_ribbon: true },
          component: () => import("@/view/pages/smartSecretary/index.vue"),
        },
        {
          path: "/setotp",
          name: "setOTP",
          meta: { title: "OTP", has_ribbon: true },
          component: () => import("@/view/pages/divar/report/setOtp.vue"),
        },
        {
          path: "/admin/smartSecretary",
          name: "admin.smartSecretary",
          meta: {
            title: "مدیریت منشی پیام ",
            has_ribbon: true,
            permission: "smartSecretary_access",
          },

          component: () =>
            import("@/view/pages/smartSecretary/admin/index.vue"),
        },
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { main_page: true },
          component: () => import("@/core/plugins/TitleRibbon/Dashboard"),
        },
        {
          path: "/",
          redirect: "/dashboard",
          name: "send.pages",
          component: () => import("@/view/pages/sendPages/sendPagesIndex"),
          children: [
            {
              path: "SendSms",
              name: "SendSms",
              meta: {
                permission: "sendSms_access",
                title: "ارسال انبوه",
                has_ribbon: true,
              },
              component: () => import("@/view/pages/sendSms/SendSms"),
            },
          ],
        },

        // {
        //   path: "/test/contact",
        //   component: () => import("@/view/pages/testContact.vue"),
        //   name: "get.contacts",
        //   meta: { title: "مخاطبین", has_ribbon: true },
        // },
        {
          path: "/socialmanagment",
          name: "social_managment",
          component: () =>
            import("@/view/pages/admin/whatsapp/whatsappSettings.vue"),
          meta: { title: "مدیریت شبکه اجتماعی", has_ribbon: true },
        },
        {
          path: "admin/socialmanagment",
          name: "admin_social_managment",
          component: () =>
            import("@/view/pages/admin/whatsapp/adminwhatsapp.vue"),
          meta: { title: "مدیریت شبکه اجتماعی ادمین", has_ribbon: true },
        },

        {
          path: "/tracking-sms",
          name: "tracking.sms",
          meta: { title: "پیامک قابل رهگیری", has_ribbon: true },
          component: () => import("@/view/pages/trackingSms/tracking.vue"),
        },
        {
          path: "/tracking-sms/receiver/:id",
          name: "tracking.sms.receiver",
          meta: { title: "لیست گیرندگان پیامک قابل رهگیری", has_ribbon: true },
          component: () =>
            import("@/view/pages/admin/trackingSms/trackingReceiver.vue"),
        },
        {
          path: "/admin/tracking-sms",
          name: "admin.tracking.sms",
          meta: {
            title: "مانیتورینگ پیامک قابل رهگیری",
            has_ribbon: true,
            permission: "admin_tracking_sms",
          },
          component: () =>
            import("@/view/pages/admin/trackingSms/tracking.vue"),
        },
        {
          path: "/admin/tracking-sms/receiver/:id",
          name: "admin.tracking.sms.receiver",
          meta: {
            title: "مانیتورینگ لیست گیرندگان پیامک قابل رهگیری",
            has_ribbon: true,
            permission: "admin_tracking_sms",
          },
          component: () =>
            import("@/view/pages/admin/trackingSms/trackingReceiver.vue"),
        },
        {
          path: "/SendSmsWallet",
          name: "SendSmsWallet",
          meta: {
            permission: "sendSms_access",
            title: "ارسال انبوه کیف پول",
            has_ribbon: true,
          },
          component: () => import("@/view/pages/sendSms/SendSmsWallet"),
        },
        {
          path: "/MapSms",
          name: "MapSms",
          meta: {
            permission: "mapSms_access",
            title: "ارسال از نقشه",
            has_ribbon: true,
          },
          component: () => import("@/view/pages/sendSms/MapSms"),
        },
        {
          path: "uploader",
          name: "uploadCenter",
          component: () => import("@/view/components/UploadCenter/Uploader"),
          meta: { title: "آپلود سنتر", has_ribbon: true },
        },
        {
          path: "awardgame",
          name: "award_game",
          component: () => import("@/view/pages/awardGame/listAwardGame.vue"),
          meta: { title: "لیست جوایز بازی", has_ribbon: true },
        },
        {
          path: "addawardgame",
          name: "add_award_game",
          component: () => import("@/view/pages/awardGame/addawardgame.vue"),
          meta: { title: "افزودن جوایز بازی", has_ribbon: true },
        },
        {
          path: "/CitySms",
          name: "send.to.city",
          meta: {
            title: "ارسال شهر و استان",
            has_ribbon: true,
            permission: "citySms_access",
          },
          component: () => import("@/view/pages/sendToCity/SendToCity"),
        },
        {
          path: "/admin/phonebook",
          name: "admin.contact.monitoring",
          component: () => import("@/view/pages/admin/contacts"),
          meta: {
            title: "مانیتورینگ دفترچه تلفن",
            permission: "contact_monitoring",
            has_ribbon: true,
          },
        },
        {
          path: "/phonebook/groups",
          name: "phonebook.groups",
          component: () =>
            import("@/view/pages/contacts/groups/contactGroupList.vue"),
          meta: {
            title: "لیست گروه‌های دفترچه تلفن",
            has_ribbon: true,
            permission: "phonebook_group_monitoring",
          },
        },
        {
          path: "/phonebook",
          name: "contacts",
          component: () => import("@/view/pages/contacts/contacts.vue"),
          meta: { title: "دفترچه تلفن", has_ribbon: true },
          children: [
            {
              path: "edit/:slug",
              name: "edit.phone.book",
              component: () => import("@/view/pages/contacts/editContact.vue"),
              meta: {
                title: "ویرایش مخاطب",
                permission: "phoneBook_access",
                has_ribbon: true,
              },
              props: true,
            },
            {
              path: "new",
              name: "new.phone.book",
              component: () => import("@/view/pages/contacts/newContact.vue"),
              meta: {
                title: "ایجاد مخاطب",
                permission: "phoneBook_access",
                has_ribbon: true,
              },
              props: true,
            },
          ],
        },
        // {
        //   path: '/phonebook',
        //   name: 'phone.book',
        //   component: () => import('@/view/pages/phoneBook/index'),
        //   meta: {title: 'دفترچه تلفن', permission: "phoneBook_access", has_ribbon: true},
        //   props: true,
        //   children: [
        //     {
        //       path: 'create',
        //       name: 'create.phone.book',
        //       component: () => import('@/view/pages/phoneBook/create.vue'),
        //       meta: {title: 'ساخت دفترچه تلفن', permission: "phoneBook_access", has_ribbon: true},
        //       props: true
        //     }
        //   ]
        // },
        {
          path: "/admin/sub-name",
          name: "admin.sub-name.index",
          component: () => import("@/view/pages/admin/subname/Index.vue"),
          meta: {
            title: "مدیریت دسته بندی خط ها",
            permission: "subName_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/sub-number",
          name: "admin.sub-number.index",
          component: () => import("@/view/pages/admin/subnumber/Index.vue"),
          meta: {
            title: "مدیریت پیش شماره ها",
            permission: "subNumber_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/sub-number/create",
          name: "admin.sub-number.create",
          component: () => import("@/view/pages/admin/subnumber/Create.vue"),
          meta: {
            title: "ایجاد شماره",
            permission: "subNumber_create",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/sub-number/:id",
          name: "admin.sub-number.edit",
          component: () => import("@/view/pages/admin/subnumber/Edit.vue"),
          meta: {
            title: "ویرایش شماره",
            permission: "subNumber_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/sub-line",
          name: "admin.sub-line.index",
          component: () => import("@/view/pages/admin/subline/Index.vue"),
          meta: {
            title: "مدیریت خط ها",
            permission: "subNumber_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/sub-line/create",
          name: "admin.sub-line.create",
          component: () => import("@/view/pages/admin/subline/Create.vue"),
          meta: {
            title: "ایجاد خط",
            permission: "subNumber_create",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/sub-line/:id",
          name: "admin.sub-line.edit",
          component: () => import("@/view/pages/admin/subline/Edit.vue"),
          meta: {
            title: "ویرایش خط",
            permission: "subNumber_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/price",
          name: "admin.price.index",
          component: () => import("@/view/pages/admin/price/Index.vue"),
          meta: {
            title: "مدیریت قیمت های پیامک",
            permission: "priceSmsAdmin_access",
            has_ribbon: true,
          },
        },

        {
          path: "/news/:id",
          name: "news.index",
          component: () => import("@/view/pages/news/News.vue"),
          meta: { title: "خبرنامه", has_ribbon: true },
          props: true,
        },

        {
          path: "/user-phone",
          name: "user.phone.create",
          component: () => import("@/view/pages/userPhone/Create"),
          meta: { title: "درخواست خرید خط", has_ribbon: true },
        },
        {
          path: "/admin/request-user-phone",
          name: "admin.user.phone",
          component: () => import("@/view/pages/admin/UserPhone/Index"),
          meta: { title: "لیست درخواست های کاربر", has_ribbon: true },
        },
        {
          path: "/phone-list",
          name: "user.phone.list",
          component: () => import("@/view/pages/userPhone/PhoneList"),
          meta: {
            title: "شماره های شما",
            permission: "phone_list_access",
            has_ribbon: true,
          },
        },
        {
          path: "/phone-list/:id",
          name: "user.phone.edit",
          component: () => import("@/view/pages/userPhone/Edit"),
          props: true,
          meta: { title: "شماره های شما", has_ribbon: true },
        },
        {
          path: "/admin/request-user-phone/:id",
          name: "admin.user.phone.edit",
          component: () => import("@/view/pages/admin/UserPhone/Edit"),
          meta: { title: "ویرایش درخواست کاربر", has_ribbon: true },
          props: true,
        },
        {
          path: "/live",
          name: "divar.report",
          component: () => import("@/view/pages/divar/report/Index"),
          meta: {
            title: "پیامک زنده",
            has_ribbon: true,
            permission: "send_message_divar",
          },
        },
        {
          path: "/live/admin",
          name: "divar.report.admin",
          component: () => import("@/view/pages/divar/report/IndexAdmin.vue"),
          meta: {
            title: "مانیتورینگ پیامک زنده",
            has_ribbon: true,
            permission: "send_message_divar",
          },
        },
        {
          path: "/live/new",
          name: "divar.report.new",
          component: () => import("@/view/pages/divar/report/IndexNew.vue"),
          meta: {
            title: "پیامک زنده هدفمند",
            has_ribbon: true,
            permission: "send_message_divar_new",
          },
        },
        {
          path: "/live/new/admin",
          name: "divar.report.new.admin",
          component: () =>
            import("@/view/pages/divar/report/IndexNewAdmin.vue"),
          meta: {
            title: "مانیتورینگ پیامک زنده هدفمند",
            has_ribbon: true,
            permission: "send_message_divar_new",
          },
        },
        {
          path: "/live/new2/admin",
          name: "divar.report.new2.admin",
          component: () =>
            import("@/view/pages/divar/report/IndexNewAdmin2.vue"),
          meta: {
            title: "اعتبارسنجی ارسال زنده",
            has_ribbon: true,
            permission: [
              "SMS_live_validation",
              "SMS_live_validation_non_payment",
            ],
          },
        },
        {
          path: "/divar-sended/:id",
          name: "divar.sended",
          component: () => import("@/view/pages/divar/report/Sended"),
          meta: { title: "گزارش شماره های ارسال زنده", has_ribbon: true },
          props: true,
        },
        {
          path: "/divar-sended/:id",
          name: "divar.sended.admin",
          component: () => import("@/view/pages/divar/report/Sended"),
          meta: { title: "گزارش شماره های ارسال زنده ادمین", has_ribbon: true },
          props: true,
        },
        {
          path: "/divar-sended-new/:id",
          name: "divar.sended.new.admin",
          component: () => import("@/view/pages/divar/report/SendedNew.vue"),
          meta: { title: "گزارش ارسال", has_ribbon: true },
          props: true,
        },
        {
          path: "/divar-sended-new-admin/:id",
          name: "divar.sended.new.admin.admin",
          component: () => import("@/view/pages/divar/report/SendedNew.vue"),
          meta: { title: "مانیتورینگ گزارش ارسال", has_ribbon: true },
          props: true,
        },
        {
          path: "/campaign",
          name: "user.campaign",
          component: () => import("@/view/pages/campaign/campaignList.vue"),
          meta: { title: "کمپین پیامکی", has_ribbon: true },
          children: [
            {
              path: ":slug",
              name: "user.campaign.edit",
              component: () => import("@/view/pages/campaign/editCampaign.vue"),
              meta: { title: "ویرایش کمپین", has_ribbon: true },
            },
            {
              path: ":slug/status",
              name: "admin.campaign.action",
              component: () =>
                import("@/view/pages/campaign/acceptRejectCampaign.vue"),
              meta: {
                title: "تایید/رد کردن کمپین",
                has_ribbon: true,
                permission: "admin_sended",
              },
            },
          ],
        },
        {
          path: "/text",
          name: "text.user.list",
          component: () => import("@/view/pages/text/Index"),
          meta: {
            title: "متون کاربر",
            has_ribbon: true,
            permission: "user_text",
          },
        },
        {
          path: "/text/create",
          name: "text.user.create",
          component: () => import("@/view/pages/text/Create"),
          meta: { title: "ایجاد متن", has_ribbon: true },
        },
        {
          path: "/text/:id",
          name: "text.user.edit",
          component: () => import("@/view/pages/text/Edit"),
          meta: { title: "اصلاح متن", has_ribbon: true },
          props: true,
        },
        {
          path: "/admin/text",
          name: "admin.text.user.list",
          component: () => import("@/view/pages/admin/text/Index"),
          meta: {
            title: "لیست پترن ادمین",
            has_ribbon: true,
            permission: "user_text",
          },
        },

        // {
        //     path: '/admin/text/create',
        //     name: 'admin.text.user.create',
        //     component: () => import('@/view/pages/admin/text/Create'),
        //     meta: {title: 'ایجاد متن', has_ribbon: true},
        //
        // },
        {
          path: "/admin/text/create",
          name: "admin.text.user.create",
          component: () => import("@/view/pages/admin/text/CreateNew"),
          meta: { title: "ایجاد متن ادمین", has_ribbon: true },
        },
        {
          path: "/admin/text/:id",
          name: "admin.text.user.edit",
          component: () => import("@/view/pages/admin/text/Edit"),
          meta: { title: "اصلاح متن", has_ribbon: true },
          props: true,
        },
        {
          path: "/admin/rcv",
          name: "admin.rcv",
          component: () => import("@/view/pages/admin/Rcv/Index"),
          meta: { title: "پیامک های دریافتی", has_ribbon: true },
        },
        {
          path: "/rcv",
          name: "user.rcv",
          component: () => import("@/view/pages/Rcv/Index"),
          meta: { title: "پیامک های دریافتی", has_ribbon: true },
        },
        {
          path: "/btn",
          name: "btn",
          component: () => import("@/view/pages/Button/HelperBtn"),
        },
        {
          path: "/admin/send-reports",
          name: "admin.sms.reports",
          component: () => import("@/view/pages/admin/reports/AdminSmsReports"),
          meta: {
            title: "گزارش ارسالی ها(مدیر)",
            permission: "admin_sended",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/reports",
          name: "admin.reports.index",
          component: () => import("@/view/pages/admin/reports/Index.vue"),
          meta: {
            title: "پیامک منتظر تایید",
            permission: "reports_access",
            has_ribbon: true,
          },
        },
        {
          path: "/reports",
          name: "reports.index",
          // component: () => import("@/view/pages/reports/UserReports.vue"),
          component: () => import("@/view/pages/reports/ReportsTabs.vue"),
          meta: {
            title: "گزارش های پیام",
            permission: "user_reports_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/reports/:id",
          name: "admin.reports.edit",
          component: () => import("@/view/pages/admin/reports/Edit.vue"),
          meta: {
            title: "ویرایش گزارش",
            permission: "reports_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/reports/socialedit",
          name: "admin.reports.edit_social_task",
          component: () => import("@/view/pages/admin/reports/SocialEdit.vue"),
          meta: {
            title: "ویرایش گزارش",
            permission: "reports_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/reports/socialedit",
          name: "reports.edit_social",
          component: () => import("@/view/pages/admin/reports/SocialEdit2.vue"),
          meta: {
            title: "نمایش گزارش",
            permission: "reports_edit",
            has_ribbon: true,
          },
          props: true,
        },

        {
          path: "/admin/reports/edit",
          name: "admin.reports.edit_task",
          component: () => import("@/view/pages/admin/reports/Edit.vue"),
          meta: {
            title: "ویرایش گزارش",
            permission: "reports_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/igap",
          name: "admin.igap",
          component: () => import("@/view/pages/admin/igap/Tokens.vue"),
          meta: {
            title: "مدیریت توکن های igap",
            permission: "igap_token_manager",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/tokens",
          name: "admin.tokens",
          component: () => import("@/view/pages/admin/divar/index.vue"),
          meta: {
            title: "مدیریت توکن های دیوار",
            permission: "divar_token",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "user-token",
          name: "user.token",
          component: () => import("@/view/pages/auth/userToken.vue"),
          meta: {
            title: "وب‌سرویس (api)",
            permission: "user_text",
            has_ribbon: true,
          },
        },
        {
          path: "admin/igap/:id",
          name: "admin.igap.edit",
          component: () => import("@/view/pages/admin/igap/Create.vue"),
          meta: {
            title: "ویرایش توکن",
            permission: "igap_token_manager",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/reports/create",
          name: "reports.create",
          // component: () => import('@/view/pages/reports/Create.vue'),
          meta: {
            title: "ایجاد گزارش",
            permission: "reports_create",
            has_ribbon: true,
          },
        },
        {
          path: "/send-reports",
          name: "user.sms.reports",
          component: () => import("@/view/pages/UserReports/SmsReports"),
          meta: { title: "گزارش درخواست ها", has_ribbon: true },
        },
        {
          path: "/reports/:id",
          name: "reports.edit",
          component: () => import("@/view/pages/reports/Edit.vue"),
          meta: {
            title: "ویرایش گزارش",
            permission: "user_reports_edit",
            has_ribbon: true,
          },
          props: true,
        },

        {
          path: "admin/wallet",
          name: "admin.wallet.index",
          component: () => import("@/view/pages/admin/newWallet/Index.vue"),
          meta: { title: "کیف پول جدید", has_ribbon: true },
        },
        {
          path: "admin/products",
          name: "admin.products.index",
          component: () =>
            import("@/view/pages/admin/newWallet/products/Index.vue"),
          meta: { title: "محصولات پیامک لند", has_ribbon: true },
        },

        {
          path: "/sended-reports/:id",
          name: "sended.reports",
          component: () => import("@/view/pages/sendedReport/Index"),
          meta: { title: "گزارش شماره های ارسال درخواست ها", has_ribbon: true },
          props: true,
        },
        {
          path: "/builder",
          name: "builder",
          component: () => import("@/view/pages/Builder.vue"),
        },
        {
          path: "/vue-bootstrap",
          name: "vue-bootstrap",
          component: () =>
            import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "alert",
              name: "vue-bootstrap-alert",
              component: () => import("@/view/pages/vue-bootstrap/Alert.vue"),
            },
            {
              path: "badge",
              name: "vue-bootstrap-badge",
              component: () => import("@/view/pages/vue-bootstrap/Badge.vue"),
            },
            {
              path: "button",
              name: "vue-bootstrap-button",
              component: () => import("@/view/pages/vue-bootstrap/Button.vue"),
            },
            {
              path: "button-group",
              name: "vue-bootstrap-button-group",
              component: () =>
                import("@/view/pages/vue-bootstrap/ButtonGroup.vue"),
            },
            {
              path: "button-toolbar",
              name: "vue-bootstrap-button-toolbar",
              component: () =>
                import("@/view/pages/vue-bootstrap/ButtonToolbar.vue"),
            },
            {
              path: "panel",
              name: "buyPanel",
              component: () => import("@/view/pages/transactions/buyPanel.vue"),
            },

            {
              path: "card",
              name: "vue-bootstrap-card",
              component: () => import("@/view/pages/vue-bootstrap/Card.vue"),
            },
            {
              path: "carousel",
              name: "vue-bootstrap-carousel",
              component: () =>
                import("@/view/pages/vue-bootstrap/Carousel.vue"),
            },
            {
              path: "collapse",
              name: "vue-bootstrap-collapse",
              component: () =>
                import("@/view/pages/vue-bootstrap/Collapse.vue"),
            },
            {
              path: "dropdown",
              name: "vue-bootstrap-dropdown",
              component: () =>
                import("@/view/pages/vue-bootstrap/Dropdown.vue"),
            },
            {
              path: "embed",
              name: "vue-bootstrap-embed",
              component: () => import("@/view/pages/vue-bootstrap/Embed.vue"),
            },
            {
              path: "form",
              name: "vue-bootstrap-form",
              component: () => import("@/view/pages/vue-bootstrap/Form.vue"),
            },
            {
              path: "form-checkbox",
              name: "vue-bootstrap-form-checkbox",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormCheckbox.vue"),
            },
            {
              path: "form-file",
              name: "vue-bootstrap-form-file",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormFile.vue"),
            },
            {
              path: "form-group",
              name: "vue-bootstrap-form-group",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormGroup.vue"),
            },
            {
              path: "form-input",
              name: "vue-bootstrap-form-input",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormInput.vue"),
            },
            {
              path: "form-radio",
              name: "vue-bootstrap-form-radio",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormRadio.vue"),
            },
            {
              path: "form-select",
              name: "vue-bootstrap-form-select",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormSelect.vue"),
            },
            {
              path: "form-textarea",
              name: "vue-bootstrap-form-textarea",
              component: () =>
                import("@/view/pages/vue-bootstrap/FormTextarea.vue"),
            },
            {
              path: "image",
              name: "vue-bootstrap-image",
              component: () => import("@/view/pages/vue-bootstrap/Image.vue"),
            },
            {
              path: "input-group",
              name: "vue-bootstrap-input-group",
              component: () =>
                import("@/view/pages/vue-bootstrap/InputGroup.vue"),
            },
            {
              path: "jumbotron",
              name: "vue-bootstrap-jumbotron",
              component: () =>
                import("@/view/pages/vue-bootstrap/Jumbotron.vue"),
            },
            {
              path: "layout-grid-system",
              name: "vue-bootstrap-layout-grid-system",
              component: () =>
                import("@/view/pages/vue-bootstrap/LayoutGridSystem.vue"),
            },
            {
              path: "link",
              name: "vue-bootstrap-link",
              component: () => import("@/view/pages/vue-bootstrap/Link.vue"),
            },
            {
              path: "list-group",
              name: "vue-bootstrap-list-group",
              component: () =>
                import("@/view/pages/vue-bootstrap/ListGroup.vue"),
            },
            {
              path: "media",
              name: "vue-bootstrap-media",
              component: () => import("@/view/pages/vue-bootstrap/Media.vue"),
            },
            {
              path: "modal",
              name: "vue-bootstrap-modal",
              component: () => import("@/view/pages/vue-bootstrap/Modal.vue"),
            },
            {
              path: "nav",
              name: "vue-bootstrap-nav",
              component: () => import("@/view/pages/vue-bootstrap/Nav.vue"),
            },
            {
              path: "navbar",
              name: "vue-bootstrap-navbar",
              component: () => import("@/view/pages/vue-bootstrap/Navbar.vue"),
            },
            {
              path: "pagination",
              name: "vue-bootstrap-pagination",
              component: () =>
                import("@/view/pages/vue-bootstrap/Pagination.vue"),
            },
            {
              path: "pagination-nav",
              name: "vue-bootstrap-pagination-nav",
              component: () =>
                import("@/view/pages/vue-bootstrap/PaginationNav.vue"),
            },
            {
              path: "notify-popover",
              name: "vue-bootstrap-popover",
              component: () => import("@/view/pages/vue-bootstrap/Popover.vue"),
            },
            {
              path: "notify-toasts",
              name: "vue-bootstrap-toasts",
              component: () => import("@/view/pages/vue-bootstrap/Toasts.vue"),
            },
            {
              path: "notify-tooltip",
              name: "vue-bootstrap-tooltip",
              component: () => import("@/view/pages/vue-bootstrap/Tooltip.vue"),
            },
            {
              path: "progress",
              name: "vue-bootstrap-progress",
              component: () =>
                import("@/view/pages/vue-bootstrap/Progress.vue"),
            },
            {
              path: "progress-spinner",
              name: "vue-bootstrap-spinner",
              component: () => import("@/view/pages/vue-bootstrap/Spinner.vue"),
            },
            {
              path: "table",
              name: "vue-bootstrap-table",
              component: () => import("@/view/pages/vue-bootstrap/Table.vue"),
            },
            {
              path: "tabs",
              name: "vue-bootstrap-tabs",
              component: () => import("@/view/pages/vue-bootstrap/Tabs.vue"),
            },
          ],
        },
        {
          path: "/custom-wizard",
          name: "wizard",
          component: () => import("@/view/pages/wizard/Wizard.vue"),
          children: [
            {
              path: "wizard-1",
              name: "wizard-1",
              component: () => import("@/view/pages/wizard/Wizard-1.vue"),
            },
            {
              path: "wizard-2",
              name: "wizard-2",
              component: () => import("@/view/pages/wizard/Wizard-2.vue"),
            },
            {
              path: "wizard-3",
              name: "wizard-3",
              component: () => import("@/view/pages/wizard/Wizard-3.vue"),
            },
            {
              path: "wizard-4",
              name: "wizard-4",
              component: () => import("@/view/pages/wizard/Wizard-4.vue"),
            },
          ],
        },
        {
          path: "/custom-plugins",
          name: "plugins",
          component: () => import("@/view/pages/plugins/Plugins.vue"),
          children: [
            {
              path: "cropper",
              name: "cropper",
              component: () => import("@/view/pages/plugins/Cropper.vue"),
            },
            {
              path: "treeselect",
              name: "treeselect",
              component: () => import("@/view/pages/plugins/Treeselect.vue"),
            },
          ],
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile.vue"),
          children: [
            {
              path: "profile-1",
              name: "profile-1",
              component: () => import("@/view/pages/profile/Profile-1.vue"),
            },
            {
              path: "profile-2",
              name: "profile-2",
              component: () => import("@/view/pages/profile/Profile-2.vue"),
            },
            {
              path: "profile-3",
              name: "profile-3",
              component: () => import("@/view/pages/profile/Profile-3.vue"),
            },
            {
              path: "profile-4",
              name: "profile-4",
              component: () =>
                import("@/view/pages/profile/DashboardUserInfo.vue"),
            },
          ],
        },
        {
          path: "/JobSms",
          name: "JobSms",
          meta: {
            permission: "jobSms_access",
            title: "ارسال به بانک اطلاعاتی",
            has_ribbon: true,
          },
          component: () => import("@/view/pages/jobs/SendToInfo.vue"),
        },
        {
          path: "/patternSms",
          name: "patternSms",
          meta: {
            permission: "gym",
            title: "باشگاه مشتریان",
            has_ribbon: true,
          },
          component: () => import("@/view/pages/pattern/index"),
        },
        {
          path: "/greetingSms",
          name: "greetingSms",
          meta: { permission: "gym", title: "پیامک مناسبتی", has_ribbon: true },
          component: () => import("@/view/pages/pattern/greetingSms"),
        },
        {
          path: "/pattern/mass",
          name: "patternMass",
          meta: {
            permission: "gym",
            title: "باشگاه مشتریان گروهی",
            has_ribbon: true,
          },
          component: () => import("@/view/pages/pattern/mass"),
        },
        {
          path: "/number/info",
          name: "NumberInfo",
          meta: {
            permission: "number_info_list",
            title: "اطلاعات شماره",
            has_ribbon: true,
          },
          component: () => import("@/view/pages/numberInfo"),
        },
        {
          path: "/suggest/text",
          name: "suggestText",
          meta: {
            permission: "user_text_request",
            title: "مشاور متن پیامک",
            has_ribbon: true,
          },
          component: () => import("@/view/content/SuggestBox/page/user/index"),
        },
        {
          path: "/admin/suggest/text",
          name: "adminSuggestText",
          meta: {
            permission: "admin_text_request",
            title: "مدیریت مشاور متن پیامک",
            has_ribbon: true,
          },
          component: () => import("@/view/content/SuggestBox/page/admin/index"),
        },
        {
          path: "/PostalSms",
          name: "SendToPostalCode",
          meta: { title: "ارسال به کدپستی", has_ribbon: true },
          component: () =>
            import("@/view/pages/sendToPostalCode/SendToPostalCode.vue"),
        },
        {
          path: "/codeSms",
          name: "send.to.code",
          meta: { title: "ارسال به کد و پیش شماره", has_ribbon: true },
          component: () => import("@/view/pages/sendToCode/sendToCode.vue"),
        },
      ],
    },
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue"),
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue"),
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue"),
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue"),
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue"),
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue"),
    },
    {
      path: "/test",
      name: "test",
      component: () => import("./view/TestPage.vue"),
    },
    {
      path: "/test-button",
      name: "test-button",
      component: () => import("./view/buttonTempl.vue"),
    },
  ],
});
